import {Component, Input, OnInit} from '@angular/core';
import {SalesMessageConfig} from '../sales-messages-section.config';

@Component({
  selector: 'app-sales-message',
  templateUrl: './sales-message.component.html',
  styleUrls: ['./sales-message.component.scss']
})
export class SalesMessageComponent implements OnInit {

  @Input() config: SalesMessageConfig;

  constructor() { }

  ngOnInit() {
  }

}
